import React, {useEffect, useState} from "react";
import '../css/ReservationPopup.css'
import firebase from "firebase";
import {Table} from "react-bootstrap";

const ReservationPopup=()=>{
    const [name,setName]=useState('');
    const [phone,setPhone]=useState('');
    const db = firebase.firestore();
    const [checkedId,setCheckedId]=useState();
    const [priceAll,setPriceAll]=useState(0);

    useEffect(() => {
        if (phone.length === 10) {
            setPhone(phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3'));
        }
        if (phone.length === 13) {
            setPhone(phone.replace(/-/g, '').replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3'));
        }
    }, [phone]);

    const handlePress = (e) => {
        const regex = /^[0-9\b -]{0,13}$/;
        if (regex.test(e.target.value)) {
            setPhone(e.target.value);
        }
    };


    const UserCheckReservation=(name,phone)=>{
        db.collection('reservation').where('username', '==', name).get().then((res)=>{
            let arr = []
            res.forEach((a)=>{
                arr.push(a.id)
            })
            return arr
        }).then(arr=>{
            if(arr.length>0){
                db.collection('reservation').where('userphone', '==', phone).get().then((res)=>
                {
                    let arr2 =[]
                    res.forEach((a)=>{
                        arr2.push(a.id)
                    })
                    const result = arr.filter((item) => arr2.includes(item))
                    return result
                }).then(id=>{
                    db.collection('reservation').doc(id[0]).get().then(res=>{
                        setCheckedId(res.data());
                    })
                })
            }else{
                alert("성함과 번호를 다시 확인 해 주세요")
                setName('')
                setPhone('')
            }

        })
    }

    const PriceSetter =(arr)=>{
        let priceAdd = 0;
        arr.map((item)=>priceAdd += parseInt(item.price)*item.quan)
        setPriceAll(priceAdd)
    }

    useEffect(()=>{
        if(checkedId){
            PriceSetter(checkedId.useritem);
        }
    },[checkedId])

    return(
        <>
            {
                checkedId?
                    <div className={'flex__center'}>
                        <span>이름: {checkedId.username}</span>
                        <span>번호: {checkedId.userphone}</span>

                        <Table className={'cart-table'}>
                            <thead className={'cart-table__thead'}>
                            <tr>
                                <th>상품명</th>
                                <th>가격</th>
                                <th>수량</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                checkedId.useritem.map(item=>(
                                    <tr key={item.name}>
                                        <th>{item.name} </th>
                                        <th>{item.price} </th>
                                        <th>{item.quan} </th>
                                    </tr>
                                ))
                            }
                            </tbody>
                            <tfoot>
                            <tr>
                                <th>총가격: {priceAll}</th>
                            </tr>
                            </tfoot>
                        </Table>
                    </div>
                    :
                    <div className={'popup-container'}>
                        <div className={"location-title-background-box"}>
                            <div className={'red-dot-box'}>
                                <div className={'red-dot'}/>
                            </div>
                            <h3>예약확인</h3>
                        </div>
                        <div className={'flex-center-row'}>
                            <div className={'login-input-box'}>
                                <input placeholder={"이름"} onChange={(e)=>setName(e.target.value)} value={name}/>
                                <input placeholder={"연락처"} onChange={handlePress} value={phone}/>
                            </div>
                            <div className={'login-button'} onClick={()=>{UserCheckReservation(name,phone)}}>
                                Login
                            </div>
                        </div>
                    </div>

            }

        </>
    );
}

export default ReservationPopup
